module.exports = __webpack_public_path__ + "static/media/6820.255a27ab.jpg";